import Header from "@/types/app/header";

export class ImportUsertHeader {
  public static header: Header[] = [
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Perfil Name",
      align: "start",
      sortable: true,
      value: "perfilName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Perfil Type",
      align: "start",
      sortable: true,
      value: "perfilType",
      class: "item-table-header",
      width: ""
    },
    {
      text: "NonUs",
      align: "start",
      sortable: true,
      value: "nonUs",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}

export class ImportFormFieldtHeader {
  public static header: Header[] = [
    {
      text: "Key",
      align: "start",
      sortable: true,
      value: "key",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Value",
      align: "start",
      sortable: true,
      value: "value",
      class: "item-table-header",
      width: ""
    },{
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}
